import { ReactNode } from 'react'
import MuiDialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import { DialogStyles as styles } from 'src/components/shared/ui/Dialog/DialogStyles'
import { LfCloseIcon } from 'src/components/shared/ui/Icons'
import { theme } from 'src/providers/ThemeProvider'

type DialogTitleProps = {
  icon?: ReactNode | null
  children?: ReactNode
  icons?: ReactNode[]
  id: string
  onClose?: (data: any) => void
  className?: string
  type?: AlertType
}

export default function DialogTitle({
  children,
  icon,
  icons = [],
  onClose,
  type = AlertType.DEFAULT,
  ...other
}: DialogTitleProps): JSX.Element {
  const { t } = useTranslation()

  return (
    <>
      {children && (
        <MuiDialogTitle {...other} sx={styles(type).title}>
          <div>
            {icon && <span>{icon}</span>}
            <Typography variant="h6">{children}</Typography>
          </div>
          <div>
            {icons.map(i => i)}
            {onClose && (
              <IconButton
                aria-label={t('actions.close')}
                onClick={onClose}
                size="large"
                sx={styles(type).closeIcon}
              >
                <LfCloseIcon htmlColor={theme.colors.gray02} />
              </IconButton>
            )}
          </div>
        </MuiDialogTitle>
      )}
    </>
  )
}
